import { Inputs } from '@taxdown/piccolo-web';
import { locizeNS, translate } from 'Services/i18n';
import { stages } from 'Constants/stages';
import { TaxScreenType } from 'Types/common';
import * as Styled from './styles';

export const STEPS_REQUIREMENTS = (): Array<{ label: string; value: number }> => [
  {
    label: translate('Dashboard.Wizard.Step.1', locizeNS.DASHBOARD),
    value: 1,
  },
  {
    label: translate('Dashboard.Wizard.Step.2', locizeNS.DASHBOARD),
    value: 2,
  },
  {
    label: translate('Dashboard.Wizard.Step.3', locizeNS.DASHBOARD),
    value: 3,
  },
  {
    label: translate('Dashboard.Wizard.Step.4', locizeNS.DASHBOARD),
    value: 4,
  },
];

export const stagesToNumber = {
  [stages.VALIDATION]: 1,
  [stages.PENDING_AUTOMATIC_MODIFICATIONS]: 3,
  [stages.TAX_AGENCY_DEBT]: 3,
  [stages.TAX_AGENCY_CLABE_ISSUED]: 3,
  [stages.FINISHED_NOT_SUCCESS]: 3,
  [stages.FINISHED_AUTOMATIC_NOT_SUCCESS]: 3,
  [stages.FINISHED_SUCCESS]: 5,
  [stages.FINISHED_TRANSFERRING]: 3,
  [stages.FINISHED_ACCEPTED]: 3,
  [stages.FILED]: 2,
  [stages.FINISHED_MISSING_CLABE]: 3,
  [stages.SUBMITTED]: 1,
  [stages.FINISHED_PAYMENT_ISSUED]: 3,
  [stages.VALIDATION_ACCEPTED]: 1,
};

const DashboardWizard = ({ tax: { stage } }: TaxScreenType): JSX.Element => {
  return (
    <Styled.WizardContainer>
      <Inputs.Wizard options={STEPS_REQUIREMENTS()} value={stagesToNumber[stage]} />
    </Styled.WizardContainer>
  );
};

export default DashboardWizard;
